export default "__VITE_ASSET__PqmuJpnx__"